export const sortByDate = (array, labelAttribute, isDec) => {
    return isDec
        ? array.sort(
            (a, b) =>
                new Date(a[labelAttribute]) - new Date(b[labelAttribute])
        )
        : array.sort(
            (a, b) =>
                new Date(b[labelAttribute]) - new Date(a[labelAttribute])
        );
};

/**
 * Sorts two dates by the day and month component
 * @param {Date} a The first date
 * @param {Date} b The second date
 * @returns 1 if b is after a, -1 otherwise
 */
export const sortByDayAndMonth = (a, b) => {
    if (b.getMonth() > a.getMonth() ||
        (b.getMonth() === a.getMonth() && b.getDate() > a.getDate())) {
        return 1;
    } else {
        return -1;
    }
}

export const sortByDayAndMonthAndYear = (a, b) => {
    if (b.getYear() > a.getYear() ||
        (b.getYear() === a.getYear() && b.getMonth() > a.getMonth() && b.getDate() > a.getDate())) {
        return 1;
    } else {
        return -1;
    }
}

/**
 * Sorts two string dates in the "dd/mm/yyyy" format
 * @param {string} a The first date
 * @param {string} b The second date
 * @returns 1 if b is after a, -1 otherwise, 0 if they are the same
 */
export const compareDateStrings = (a, b) => {
    var split = a.split("/");
    var newDate = split[1] + "/" + split[0] + "/" + split[2];
    var date1 = new Date(newDate);

    split = b.split("/");
    newDate = split[1] + "/" + split[0] + "/" + split[2];
    var date2 = new Date(newDate);

    if (date2 < date1) return -1;
    if (date2 > date1) return 1;
    return 0;
}

/**
 * Sorts two dates
 * @param {Date} a The first date
 * @param {Date} b The second date
 * @returns 1 if b is after a, -1 otherwise, 0 if they are the same
 */
export const compareDates = (a, b) => {
    if (b < a) return -1;
    if (b > a) return 1;
    return 0;
}
